import {
  isSmoothScrollSupported,
  scrollToPosition,
} from 'approot/shared/logic/scroll-fallback.utils';

export function handleSlideScroll(
  slide: HTMLElement,
  slideContainer: HTMLElement
) {
  isSmoothScrollSupported()
    ? slide.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest',
      })
    : scrollToPosition({
        element: slideContainer,
        position: slide.offsetLeft,
      });
}

export function scrollSlideContainerBy(
  slideContainer: HTMLElement,
  slide: HTMLElement,
  horizontalOffsetDirection: 'left' | 'right'
) {
  isSmoothScrollSupported()
    ? slideContainer.scrollBy({
        left:
          horizontalOffsetDirection === 'right'
            ? slide.scrollWidth
            : -slide.scrollWidth,
        behavior: 'smooth',
      })
    : scrollToPosition({
        element: slideContainer,
        position: slide.offsetLeft,
      });
}
